import { useGetAllPersons } from '@hr/api/endpoints'
import { IconFemale, IconMale } from '@hr/common/icons'
import { LoadingContainer } from '@hr/common/loaders/loadingcontainer'
import { useTranslation } from 'react-i18next'
import styles from './Card.module.css'

export function GenderDistribution() {
	const { t } = useTranslation()
	const { data: persons } = useGetAllPersons()

	const countGenders = () => {
		let male = 0
		let female = 0
		persons.forEach((person) => {
			const status = person.employmentDetails?.personStatus
			if ((status === 'EMPLOYED' || !status) && person.socSec) {
				const g = (person.gender || '').trim().toUpperCase()
				if (g === 'M') ++male
				else if (g === 'N') ++female
			}
		})

		const total = male + female
		if (total === 0) return

		return (
			<>
				<h4 className={styles.cardHeader}>{t('GenderDistribution', 'Sukupuolijakauma')}</h4>
				<div className={styles.genderWrapper}>
					<p>
						<IconFemale />
						<b className={styles.bigFigure}>{female}</b>
						{t('Women', 'Naiset')}
					</p>
					<p>
						<IconMale />
						<b className={styles.bigFigure}>{male}</b>
						{t('Men', 'Miehet')}
					</p>
				</div>
			</>
		)
	}

	return persons ? countGenders() : <LoadingContainer />
}
